export default __webpack_public_path__ + "static/media/HU.a0d5d04c.svg";